import storage from 'good-storage'

let cache = {
    local:storage,
    session:storage.session
};

export default cache;
